import { request, requestPage } from '@/lib/apiClient';

/** The public catalogue: /storefront/*. No authentication required anywhere. */
export const storefrontApi = {
  /** Everything the home page renders, in one request. */
  home: () => request({ url: '/storefront/home' }),

  categories: () => request({ url: '/storefront/categories' }),

  products: ({ page = 1, limit = 24, q, categoryIds, sort } = {}) =>
    requestPage({
      url: '/storefront/products',
      params: {
        page,
        limit,
        ...(q ? { q } : {}),
        // Repeated `category_ids` params; axios serialises an array this way,
        // which is what FastAPI's `list[UUID] = Query()` expects.
        ...(categoryIds?.length ? { category_ids: categoryIds } : {}),
        ...(sort ? { sort } : {}),
      },
    }),

  /** `shop` (a subdomain) picks the listing on the main page, where slugs repeat. */
  product: (slug, shop) =>
    request({ url: `/storefront/products/${slug}`, params: shop ? { shop } : undefined }),
  offers: (productId) => request({ url: `/storefront/products/${productId}/offers` }),
  // Wishlist
  getWishlist: () => request({ url: '/storefront/wishlist' }),
  addToWishlist: (productId) =>
    request({ url: `/storefront/wishlist/${productId}`, method: 'POST' }),
  removeFromWishlist: (productId) =>
    request({ url: `/storefront/wishlist/${productId}`, method: 'DELETE' }),
};
